module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-aichi-1-e89f7c441032c625b167f45225f2f30e.png";